module.exports = __webpack_public_path__ + "img/gxbj-img.b071963f.png";